/**
 * 树转一维数组
 * @param tree
 * @return {*[]}
 */
export function treeToArray(tree) {
  let res = [];
  for (const item of tree) {
    const { children } = item;
    if (children && children.length) {
      res = res.concat(treeToArray(children));
    }
    res.push(item);
  }
  return res;
}

/**
 * 树查找
 * @param tree
 * @param func 回调方法
 * @return {null|*}
 */
export function treeFind(tree, func) {
  for (const data of tree) {
    if (func(data)) return data;

    if (data.children) {
      const res = treeFind(data.children, func);
      if (res) return res;
    }
  }
  return null;
}
